import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const P = (pid) => `${API}/projects/${pid}`;

export const controls = {
  // RFI
  listRfis: (pid, params) => axios.get(`${P(pid)}/rfis`, { params }).then((r) => r.data),
  createRfi: (pid, body) => axios.post(`${P(pid)}/rfis`, body).then((r) => r.data),
  getRfi: (pid, id) => axios.get(`${P(pid)}/rfis/${id}`).then((r) => r.data),
  rfiAction: (pid, id, action, body = {}) =>
    axios.post(`${P(pid)}/rfis/${id}/${action}`, body).then((r) => r.data),
  rfiRegisterUrl: (pid) => `${P(pid)}/rfis-register.csv`,
  // Submittals
  listSubmittals: (pid, params) => axios.get(`${P(pid)}/submittals`, { params }).then((r) => r.data),
  createSubmittal: (pid, body) => axios.post(`${P(pid)}/submittals`, body).then((r) => r.data),
  getSubmittal: (pid, id) => axios.get(`${P(pid)}/submittals/${id}`).then((r) => r.data),
  submittalAction: (pid, id, action, body = {}) =>
    axios.post(`${P(pid)}/submittals/${id}/${action}`, body).then((r) => r.data),
  submittalRegisterUrl: (pid) => `${P(pid)}/submittals-register.csv`,
  // Material Approval / MIR
  listMir: (pid, params) => axios.get(`${P(pid)}/material-approvals`, { params }).then((r) => r.data),
  createMir: (pid, body) => axios.post(`${P(pid)}/material-approvals`, body).then((r) => r.data),
  getMir: (pid, id) => axios.get(`${P(pid)}/material-approvals/${id}`).then((r) => r.data),
  mirAction: (pid, id, action, body = {}) => axios.post(`${P(pid)}/material-approvals/${id}/${action}`, body).then((r) => r.data),
  mirRegisterUrl: (pid) => `${P(pid)}/material-approvals-register.csv`,
  // Method Statements
  listMs: (pid, params) => axios.get(`${P(pid)}/method-statements`, { params }).then((r) => r.data),
  createMs: (pid, body) => axios.post(`${P(pid)}/method-statements`, body).then((r) => r.data),
  getMs: (pid, id) => axios.get(`${P(pid)}/method-statements/${id}`).then((r) => r.data),
  msAction: (pid, id, action, body = {}) => axios.post(`${P(pid)}/method-statements/${id}/${action}`, body).then((r) => r.data),
  msRegisterUrl: (pid) => `${P(pid)}/method-statements-register.csv`,
  // ITP / Hold-Witness
  listItp: (pid, params) => axios.get(`${P(pid)}/itps`, { params }).then((r) => r.data),
  createItp: (pid, body) => axios.post(`${P(pid)}/itps`, body).then((r) => r.data),
  getItp: (pid, id) => axios.get(`${P(pid)}/itps/${id}`).then((r) => r.data),
  itpAction: (pid, id, action, body = {}) => axios.post(`${P(pid)}/itps/${id}/${action}`, body).then((r) => r.data),
  itpStageAction: (pid, id, stageId, action, body = {}) => axios.post(`${P(pid)}/itps/${id}/stages/${stageId}/${action}`, body).then((r) => r.data),
  itpRegisterUrl: (pid) => `${P(pid)}/itps-register.csv`,
  // ---- Phase 8C: PTW / JSA / Toolbox / Incident
  listJsa: (pid, params) => axios.get(`${P(pid)}/jsas`, { params }).then((r) => r.data),
  createJsa: (pid, b) => axios.post(`${P(pid)}/jsas`, b).then((r) => r.data),
  jsaAction: (pid, id, a, b = {}) => axios.post(`${P(pid)}/jsas/${id}/${a}`, b).then((r) => r.data),
  listPtw: (pid, params) => axios.get(`${P(pid)}/permits`, { params }).then((r) => r.data),
  createPtw: (pid, b) => axios.post(`${P(pid)}/permits`, b).then((r) => r.data),
  ptwAction: (pid, id, a, b = {}) => axios.post(`${P(pid)}/permits/${id}/${a}`, b).then((r) => r.data),
  listTbt: (pid, params) => axios.get(`${P(pid)}/toolbox-talks`, { params }).then((r) => r.data),
  createTbt: (pid, b) => axios.post(`${P(pid)}/toolbox-talks`, b).then((r) => r.data),
  tbtAttendee: (pid, id, b) => axios.post(`${P(pid)}/toolbox-talks/${id}/attendees`, b).then((r) => r.data),
  listInc: (pid, params) => axios.get(`${P(pid)}/incidents`, { params }).then((r) => r.data),
  createInc: (pid, b) => axios.post(`${P(pid)}/incidents`, b).then((r) => r.data),
  incAction: (pid, id, a, b = {}) => axios.post(`${P(pid)}/incidents/${id}/${a}`, b).then((r) => r.data),
};

export const RFI_STATUS_COLOR = {
  DRAFT: 'bg-slate-100 text-slate-700',
  SUBMITTED: 'bg-blue-100 text-blue-700',
  ASSIGNED: 'bg-indigo-100 text-indigo-700',
  UNDER_REVIEW: 'bg-amber-100 text-amber-700',
  ANSWERED: 'bg-emerald-100 text-emerald-700',
  RETURNED_FOR_CLARIFICATION: 'bg-orange-100 text-orange-700',
  CLOSED: 'bg-green-100 text-green-800',
  REOPENED: 'bg-purple-100 text-purple-700',
  CANCELLED: 'bg-rose-100 text-rose-700',
};

export const SUB_STATUS_COLOR = {
  DRAFT: 'bg-slate-100 text-slate-700',
  SUBMITTED: 'bg-blue-100 text-blue-700',
  UNDER_REVIEW: 'bg-amber-100 text-amber-700',
  APPROVED: 'bg-green-100 text-green-800',
  APPROVED_WITH_COMMENTS: 'bg-emerald-100 text-emerald-700',
  REVISE_AND_RESUBMIT: 'bg-orange-100 text-orange-700',
  REJECTED: 'bg-rose-100 text-rose-700',
  SUPERSEDED: 'bg-slate-200 text-slate-600',
  CANCELLED: 'bg-rose-100 text-rose-700',
};

export const QC_STATUS_COLOR = {
  DRAFT: 'bg-slate-100 text-slate-700',
  SUBMITTED: 'bg-blue-100 text-blue-700',
  INTERNAL_REVIEW: 'bg-sky-100 text-sky-700',
  UNDER_REVIEW: 'bg-amber-100 text-amber-700',
  ACCEPTED: 'bg-green-100 text-green-800',
  ACCEPTED_WITH_REMARKS: 'bg-emerald-100 text-emerald-700',
  APPROVED: 'bg-green-100 text-green-800',
  APPROVED_WITH_CONDITIONS: 'bg-emerald-100 text-emerald-700',
  REVISE_AND_RESUBMIT: 'bg-orange-100 text-orange-700',
  REJECTED: 'bg-rose-100 text-rose-700',
  QUARANTINED: 'bg-fuchsia-100 text-fuchsia-700',
  REINSPECTION: 'bg-orange-100 text-orange-700',
  SUPERSEDED: 'bg-slate-200 text-slate-600',
  CANCELLED: 'bg-rose-100 text-rose-700',
  APPROVED_ITP: 'bg-blue-100 text-blue-700',
  ACTIVE: 'bg-cyan-100 text-cyan-800',
};

export const STAGE_STATUS_COLOR = {
  PENDING: 'bg-slate-100 text-slate-600',
  IN_PROGRESS: 'bg-amber-100 text-amber-700',
  PASSED: 'bg-green-100 text-green-800',
  RELEASED: 'bg-green-100 text-green-800',
  WAIVED: 'bg-slate-200 text-slate-600',
  FAILED: 'bg-rose-100 text-rose-700',
};
